import CardNumber from './card-number.vue';

export default CardNumber;
